/** Pure barrel — re-exports only side-effect-free modules */
/* eslint-disable @typescript-eslint/no-restricted-imports */
export * from "./xml/pure";
export * from "./model/pure";
